import { css } from '@emotion/react';
import { useTheme } from '@mui/material';

export const useStyles = () => {
  const theme = useTheme();
  return {
    root: css`
      flex: 1;
      margin-left: ${theme.spacing(4)};
      ${theme.breakpoints.down('lg')} {
        margin-left: 0;
      }
    `,
    paper: css`
      padding: ${theme.spacing(6)};
      margin-bottom: ${theme.spacing(4)};
    `,
    headerSection: css`
      margin-bottom: ${theme.spacing(6)};
    `,
    title: css`
      margin-bottom: ${theme.spacing(4)};
      font-weight: 600;
      color: ${theme.palette.text.primary};
    `,
    overviewGrid: css`
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
      gap: ${theme.spacing(4)};
      ${theme.breakpoints.down('md')} {
        grid-template-columns: 1fr 1fr;
        gap: ${theme.spacing(3)};
      }
      ${theme.breakpoints.down('sm')} {
        grid-template-columns: 1fr;
        gap: ${theme.spacing(2)};
      }
    `,
    statCard: css`
      padding: ${theme.spacing(4)};
      border-radius: ${theme.spacing(3)};
      display: flex;
      align-items: center;
      gap: ${theme.spacing(3)};
      color: white;
      position: relative;
      overflow: hidden;
    `,
    gradientPrimary: css`
      background: linear-gradient(135deg, rgba(56, 57, 68, 1) 0%, rgba(56, 57, 68, 1) 100%);
    `,
    gradientSecondary: css`
      background: linear-gradient(135deg, rgba(56, 57, 68, 1) 0%, rgba(56, 57, 68, 1) 100%);
    `,
    gradientTertiary: css`
      background: linear-gradient(135deg, rgba(56, 57, 68, 1) 0%, rgba(56, 57, 68, 1) 100%);
    `,
    gradientQuaternary: css`
      background: linear-gradient(135deg, rgba(56, 57, 68, 1) 0%, rgba(56, 57, 68, 1) 100%);
    `,
    statIcon: css`
      width: 48px;
      height: 48px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(255, 255, 255, 0.2);
      border-radius: 50%;
    `,
    statContent: css`
      flex: 1;
    `,
    statNumber: css`
      font-weight: 700;
      line-height: 1;
      margin-bottom: ${theme.spacing(1)};
    `,
    statLabel: css`
      opacity: 0.9;
      font-weight: 500;
    `,
    sectionTitle: css`
      margin-bottom: ${theme.spacing(4)};
      font-weight: 600;
      color: ${theme.palette.text.primary};
    `,
    levelSection: css`
      margin-bottom: ${theme.spacing(6)};
    `,
    levelGrid: css`
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
      gap: ${theme.spacing(3)};
      ${theme.breakpoints.down('sm')} {
        grid-template-columns: 1fr;
      }
    `,
    levelCard: css`
      border: 1px solid ${theme.palette.interactive.delimiter};
      border-radius: ${theme.spacing(2)};
      padding: ${theme.spacing(4)};
      background: ${theme.palette.background.paper};
      transition: all 0.2s ease;
      
      &:hover {
        border-color: ${theme.palette.interactive.primary};
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      }
    `,
    levelHeader: css`
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: ${theme.spacing(3)};
    `,
    levelTitle: css`
      font-weight: 600;
      color: ${theme.palette.interactive.primary};
    `,
    levelStats: css`
      display: flex;
      justify-content: space-between;
      gap: ${theme.spacing(2)};
    `,
    levelStat: css`
      text-align: center;
      flex: 1;
    `,
    levelNumber: css`
      font-weight: 700;
      color: ${theme.palette.text.primary};
      margin-bottom: ${theme.spacing(1)};
    `,
    levelLabel: css`
      color: ${theme.palette.text.secondary};
    `,
    emptyState: css`
      text-align: center;
      padding: ${theme.spacing(8)};
      color: ${theme.palette.text.secondary};
    `,
    emptyIcon: css`
      font-size: 48px;
      margin-bottom: ${theme.spacing(2)};
      opacity: 0.5;
    `,
    emptyText: css`
      margin-bottom: ${theme.spacing(1)};
    `,
    emptySubtext: css`
      opacity: 0.7;
    `,
    actionSection: css`
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: ${theme.spacing(6)};
      ${theme.breakpoints.down('md')} {
        grid-template-columns: 1fr;
        gap: ${theme.spacing(4)};
      }
    `,
    referrerSection: css`
      
    `,
    referrerCard: css`
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: ${theme.spacing(3)};
      border: 1px solid ${theme.palette.interactive.success};
      border-radius: ${theme.spacing(2)};
      background: ${theme.palette.background.paper};
    `,
    referrerInfo: css`
      display: flex;
      align-items: center;
      gap: ${theme.spacing(2)};
    `,
    referrerIcon: css`
      color: ${theme.palette.interactive.success};
    `,
    referrerLabel: css`
      font-weight: 500;
      margin-bottom: ${theme.spacing(0.5)};
    `,
    referrerAddress: css`
      font-family: monospace;
      color: ${theme.palette.text.secondary};
    `,
    verifiedIcon: css`
      color: ${theme.palette.interactive.success};
    `,
    noReferrerCard: css`
      display: flex;
      align-items: center;
      gap: ${theme.spacing(2)};
      padding: ${theme.spacing(3)};
      border: 1px solid ${theme.palette.interactive.delimiter};
      border-radius: ${theme.spacing(2)};
      background: ${theme.palette.background.paper};
    `,
    noReferrerIcon: css`
      color: ${theme.palette.text.secondary};
    `,
    noReferrerText: css`
      color: ${theme.palette.text.secondary};
    `,
    feeSection: css`
      
    `,
    feeContainer: css`
      margin-bottom: ${theme.spacing(4)};
    `,
    feeInfo: css`
      margin-top: ${theme.spacing(2)};
      padding: ${theme.spacing(2)};
      background: ${theme.palette.background.default};
      border-radius: ${theme.spacing(1)};
      display: flex;
      justify-content: space-between;
      align-items: center;
    `,
    feeLabel: css`
      color: ${theme.palette.text.secondary};
    `,
    feeAmount: css`
      font-weight: 500;
      color: ${theme.palette.text.primary};
    `,
    buttonGroup: css`
      width: 100%;
    `,
    potentialRewardBanner: css`
      display: flex;
      align-items: center;
      gap: ${theme.spacing(3)};
      padding: ${theme.spacing(4)};
      background: linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%);
      border-radius: ${theme.spacing(2)};
      margin-top: ${theme.spacing(4)};
    `,
    trendingIcon: css`
      color: #e67e22;
      font-size: 24px;
    `,
    bannerContent: css`
      flex: 1;
    `,
    bannerTitle: css`
      font-weight: 600;
      color: #e67e22;
      margin-bottom: ${theme.spacing(1)};
    `,
    bannerText: css`
      color: #d35400;
    `,
    actionButton: css`
      width: 100%;
      ${theme.breakpoints.down('lg')} {
        width: auto;
      }
      ${theme.breakpoints.down('sm')} {
        width: 100%;
      }
    `,
    clickableText: css`
      color: ${theme.palette.interactive.primary};
      :hover {
        color: ${theme.palette.text.primary};
        cursor: pointer;
      }
    `,
    votingWeightContainer: css`
      padding-bottom: ${theme.spacing(4)};
      ${theme.breakpoints.down('lg')} {
        border-right: 1px solid ${theme.palette.interactive.delimiter};
        padding-right: ${theme.spacing(10)};
        padding-bottom: 0;
      }
      ${theme.breakpoints.down('sm')} {
        border-right: none;
        padding-bottom: ${theme.spacing(4)};
      }
    `,
    totalLockedContainer: css`
      margin: ${theme.spacing(4)} 0 ${theme.spacing(5)} 0;
      ${theme.breakpoints.down('lg')} {
        margin-bottom: 0;
      }
      ${theme.breakpoints.down('sm')} {
        margin-bottom: ${theme.spacing(5)};
      }
    `,
    tokenIcon: css`
      height: ${theme.spacing(6.5)};
      width: ${theme.spacing(6.5)};
    `,
    totalLockedValue: css`
      display: flex;
      flex-direction: row;
      padding-bottom: ${theme.spacing(2)};
    `,
    totalLockedText: css`
      margin-right: ${theme.spacing(2)};
    `,
    voteSection: css`
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding: ${theme.spacing(6)};
      ${theme.breakpoints.down('lg')} {
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
      }
    `,
    subtitle: css`
      margin-bottom: ${theme.spacing(1)};
      ${theme.breakpoints.down('md')} {
        font-size: ${theme.typography.small1.fontSize};
      }
      ${theme.breakpoints.down('sm')} {
        font-size: ${theme.typography.body1.fontSize};
      }
    `,
    address: css`
      margin-bottom: ${theme.spacing(1)};
      ${theme.breakpoints.down('md')} {
        font-size: ${theme.typography.small1.fontSize};
      }
      ${theme.breakpoints.down('sm')} {
        font-size: ${theme.typography.tiny.fontSize};
      }
    `,
    value: css`
      ${theme.breakpoints.down('md')} {
        font-size: ${theme.typography.h4.fontSize};
      }
      ${theme.breakpoints.down('sm')} {
        font-size: ${theme.typography.h3.fontSize};
      }
    `,
    votingWalletPaper: css`
      display: flex;
      flex-direction: column;
      margin-top: ${theme.spacing(6)};
      ${theme.breakpoints.down('lg')} {
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
      }
      ${theme.breakpoints.down('sm')} {
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
      }
    `,
    toVote: css`
      margin-bottom: ${theme.spacing(4)};
    `,
    depositTokens: css`
      margin-bottom: ${theme.spacing(3)};
    `,
    delimiter: css`
      ${theme.breakpoints.down('lg')} {
        display: none;
      }
      ${theme.breakpoints.down('sm')} {
        display: block;
        width: 100%;
      }
    `,
    infoIcon: css`
      display: flex;
      align-self: center;
    `,
    totalLockedTitle: css`
      display: flex;
      flex-direction: row;
      align-items: flex-end;
    `,
  };
};
